import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { CAUSE_OF_STRESS, PATIENT_GREATEST_NEED } from '../constants';
export const NeedsConcerns = ({
  patient
}) => patient[PATIENT_GREATEST_NEED] || patient[CAUSE_OF_STRESS] ? /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, `${defaults.patientsGreatestNeedConcern}: `), /*#__PURE__*/React.createElement(View, {
  style: styles.row
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.width50, styles.textAlignCenter, styles.pYPointOneCm]
}, /*#__PURE__*/React.createElement(View, {
  style: {
    textAlign: 'left'
  }
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.patientsGreatestNeed}: `), /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetText
}, patient[PATIENT_GREATEST_NEED]))), /*#__PURE__*/React.createElement(View, {
  style: [styles.width50, styles.textAlignCenter, styles.pYPointOneCm]
}, /*#__PURE__*/React.createElement(View, {
  style: {
    textAlign: 'left'
  }
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, `${defaults.patientsGreatestConcern}: `), /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetText
}, patient[CAUSE_OF_STRESS]))))) : /*#__PURE__*/React.createElement(React.Fragment, null);